export const CookieConsentsName = 'cookie_consents';

export enum CookieConsentsValue {
  Accept = 'accept',
  Decline = 'decline',
}
